import type { FunctionComponent, ReactNode } from 'react';

import { Button, Modal } from '@dr.pogodin/react-utils';

import Throbber from 'components/Throbber';

import IconFail from 'assets/images/icon-fail-48px.svg';
import IconOk from 'assets/images/icon-ok-48px.svg';

import IconWarn from 'assets/images/icon-warning-48px.svg';

import secondaryButtonTheme from 'themes/Button/admin/secondary.scss';

import modalTheme from './modal.theme.scss';
import './style.scss';

export type IconT = 'FAIL' | 'OK' | 'WARN';

type ButtonThemeT = Exclude<Parameters<typeof Button>[0]['theme'], undefined>;

const ICONS: Record<IconT, ReactNode> = {
  FAIL: <IconFail />,
  OK: <IconOk />,
  WARN: <IconWarn />,
};

type PropsT = {
  busy?: boolean;
  cancelButtonLabel?: string;
  cancelButtonTheme?: ButtonThemeT;
  children: ReactNode;
  confirmButtonLabel?: string;
  confirmButtonTheme?: ButtonThemeT;
  icon: IconT;
  onCancel: () => void;
  onConfirm?: () => void;
};

const MessageModal: FunctionComponent<PropsT> = ({
  busy,
  cancelButtonLabel = 'Cancel',
  cancelButtonTheme,
  children,
  confirmButtonLabel = 'Ok',
  confirmButtonTheme,
  icon,
  onCancel,
  onConfirm,
}) => {
  let buttons: ReactNode | undefined;
  if (busy) buttons = <div styleName="throbber"><Throbber /></div>;
  else {
    buttons = (
      <Button
        onClick={onCancel}
        theme={cancelButtonTheme ?? secondaryButtonTheme}
      >
        {cancelButtonLabel}
      </Button>
    );
    if (onConfirm) {
      buttons = (
        <>
          {buttons}
          <Button
            onClick={onConfirm}
            theme={confirmButtonTheme}
          >
            {confirmButtonLabel}
          </Button>
        </>
      );
    }
  }

  return (
    <Modal onCancel={onCancel} theme={modalTheme}>
      {ICONS[icon]}
      <div styleName="content">
        {children}
      </div>
      <div styleName="buttons">
        {buttons}
      </div>
    </Modal>
  );
};

export default MessageModal;
